import React, { forwardRef, useState } from 'react'
import PropTypes from 'prop-types'
import { theme } from '../../../../../tailwind.config'
import Icon from '@components/Icon'

const EmojiRadioButtonScale = (props) => {
  const { onSelect, name, innerRef } = props
  const [selected, setSelected] = useState()

  return (
    <>
      <div className={'flex justify-between mb-2 mx-2'}>
        {[...Array(5).keys()].map((v) => {
          const value = v + 1

          return (
            <EmojiRadio
              key={value}
              onChange={(event) => {
                setSelected(parseInt(event.target.value))
                if (onSelect) onSelect(parseInt(event.target.value))
              }}
              name={name}
              value={value}
              ref={innerRef}
              active={selected === value ? 'true' : 'false'}
            />
          )
        })}
      </div>
    </>
  )
}

const EmojiRadio = forwardRef((props, ref) => {
  const { value, active } = props

  let icon = ''
  let color = ''

  if (value === 1) {
    icon = 'EmojiRatingOne'
    color = 'feedbackOne'
  }
  if (value === 2) {
    icon = 'EmojiRatingTwo'
    color = 'feedbackTwo'
  }
  if (value === 3) {
    icon = 'EmojiRatingThree'
    color = 'feedbackThree'
  }
  if (value === 4) {
    icon = 'EmojiRatingFour'
    color = 'feedbackFour'
  }
  if (value === 5) {
    icon = 'EmojiRatingFive'
    color = 'feedbackFive'
  }

  return (
    <label htmlFor={props.id} className={'flex cursor-pointer'}>
      <div className={'relative w-[48px] h-[48px]'}>
        <input
          type={'radio'}
          {...props}
          ref={ref}
          className={'absolute opacity-0'}
        />
        {icon && (
          <Icon
            icon={icon}
            iconClasses={`w-[48px] h-[48px] hover:text-${color} ${
              active === 'true' ? `text-${color}` : 'text-white'
            }`}
          />
        )}
      </div>
    </label>
  )
})

EmojiRadioButtonScale.propTypes = {
  name: PropTypes.string,
  onSelect: PropTypes.func,
  innerRef: PropTypes.func,
}

export default EmojiRadioButtonScale
